var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "return-print-list_box", attrs: { id: "returnOrderInfo" } },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.saveLoading,
              expression: "saveLoading",
            },
          ],
          ref: "ruleForm",
          attrs: {
            inline: false,
            "label-width": "0px",
            model: _vm.data,
            rules: _vm.rules,
          },
        },
        [
          _c("div", { staticClass: "reutrn-box y-mt-10" }, [
            _c("div", { staticClass: "trangle" }),
            _c("div", { staticClass: "y-f y-f-a" }, [
              _c(
                "div",
                { staticClass: "y-f y-f-a y-f-fc icon-box" },
                [
                  _c("svg-icon", {
                    staticClass: "icon-send-style",
                    attrs: { "icon-class": "icon_Send " },
                  }),
                  _c("span", { staticClass: "y-fc-systemcolor" }, [
                    _vm._v("寄件地址"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "y-mt-10" }, [
                _c("div", { staticClass: "y-f y-f-a" }, [
                  _c("span", { staticClass: "recive-select-btn" }, [
                    _c(
                      "span",
                      {
                        staticClass: "radio-btn y-mr-4",
                        class: { "active-radio-btn": _vm.senderModel == "X" },
                        on: {
                          click: function ($event) {
                            return _vm.changeSenderModel("X")
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "radio-btn",
                        class: { "active-radio-btn": _vm.senderModel == "T" },
                        on: {
                          click: function ($event) {
                            return _vm.changeSenderModel("T")
                          },
                        },
                      },
                      [_vm._v("填写")]
                    ),
                  ]),
                ]),
                _c("div", [
                  _vm.senderModel == "X"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "y-f y-mt-8 y-f-a y-mb-0" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: { label: "", "label-width": "" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "y-w-600 remote-style",
                                    attrs: {
                                      "popper-append-to-body": false,
                                      "popper-class": "y-w-600",
                                      filterable: "",
                                      remote: "",
                                      placeholder: "请输入关键词",
                                      "remote-method": _vm.remoteMethod,
                                      loading: _vm.addrLoading,
                                    },
                                    on: {
                                      "visible-change": _vm.initAddrInfo,
                                      change: function ($event) {
                                        return _vm.getAddressList()
                                      },
                                    },
                                    model: {
                                      value: _vm.addressId,
                                      callback: function ($$v) {
                                        _vm.addressId = $$v
                                      },
                                      expression: "addressId",
                                    },
                                  },
                                  _vm._l(_vm.options, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "y-f y-f-a y-mt-8 y-f-js y-mb-0" },
                        [
                          _c("div", { staticClass: "y-f" }, [
                            _c("div", {}, [
                              _c(
                                "div",
                                { staticClass: "y-f y-f-jb" },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "", prop: "sendName" } },
                                    [
                                      _c("el-autocomplete", {
                                        staticClass: "y-w-180",
                                        attrs: {
                                          "popper-class": "print-list_w500",
                                          "fetch-suggestions":
                                            _vm.querySearchAsync,
                                          debounce: 0,
                                          placeholder: "请输入发件人姓名",
                                        },
                                        on: { select: _vm.handleSelectSender },
                                        model: {
                                          value: _vm.data.sendName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "sendName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "data.sendName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "sendMobile",
                                      attrs: {
                                        label: "",
                                        prop: "sendMobile",
                                        "label-width": "0",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "y-w-180",
                                        attrs: {
                                          maxlength: 11,
                                          placeholder: "请输入手机号码",
                                        },
                                        model: {
                                          value: _vm.data.sendMobile,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "sendMobile",
                                              $$v
                                            )
                                          },
                                          expression: "data.sendMobile",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "sendPhone",
                                      attrs: {
                                        label: "",
                                        prop: "sendPhone",
                                        "label-width": "0",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "y-w-180",
                                        attrs: {
                                          maxlength: 20,
                                          placeholder: "请输入电话号码",
                                        },
                                        model: {
                                          value: _vm.data.sendPhone,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.data, "sendPhone", $$v)
                                          },
                                          expression: "data.sendPhone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "",
                                        prop: "districtSend",
                                      },
                                    },
                                    [
                                      _c("regionSelector", {
                                        ref: "areaListSend",
                                        attrs: {
                                          id: "sendArea",
                                          isDisable: _vm.isSendHy,
                                          areaList: _vm.areaListSend,
                                          fromPage: "printList",
                                        },
                                        on: {
                                          changeRegion: _vm.changeRegionSend,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "y-f y-f-a y-f-jb big-screen" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "y-mb-0",
                                      attrs: { label: "", prop: "sendAddress" },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "y-w-500",
                                        attrs: {
                                          maxlength: 255,
                                          placeholder:
                                            "请输入详细地址(街道、社区、门牌号等)",
                                        },
                                        model: {
                                          value: _vm.data.sendAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "sendAddress",
                                              $$v
                                            )
                                          },
                                          expression: "data.sendAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "clear-text",
                                      attrs: {
                                        disabled: _vm.sourceOperation == 2,
                                      },
                                      model: {
                                        value: _vm.data.checkedSender,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "checkedSender",
                                            $$v
                                          )
                                        },
                                        expression: "data.checkedSender",
                                      },
                                    },
                                    [_vm._v("保存到地址簿")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "clear-text systemColor",
                                      on: { click: _vm.clearSenderInfo },
                                    },
                                    [_vm._v("清空内容")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "y-b-s y-h-120" }, [
                              _c(
                                "div",
                                { staticClass: "anlysize-style y-b-s" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      resize: "none",
                                      rows: 4,
                                      maxlength: 200,
                                      placeholder:
                                        "觉得填写麻烦？粘贴发件人信息到此处，点击一键解析，系统将自动填写。如 张三 18223459856 陕西省西安市雁塔区锦业路中心大厦",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.blurAddr("send")
                                      },
                                    },
                                    model: {
                                      value: _vm.totalInfoSend,
                                      callback: function ($$v) {
                                        _vm.totalInfoSend = $$v
                                      },
                                      expression: "totalInfoSend",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "y-f y-f-je y-f-a" },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass:
                                            "identify-avatar-uploader",
                                          attrs: {
                                            action: "",
                                            accept: ".jpg,.jpeg,.png",
                                            "show-file-list": false,
                                            "before-upload":
                                              _vm.beforeAvatarUploadSend,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "systemColor align-right systemSize",
                                            },
                                            [_vm._v("图片识别")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "systemColor align-right systemSize",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.smartResolve("send")
                                            },
                                          },
                                        },
                                        [_vm._v("一键解析")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm.sendUploadedImage
                              ? _c("div", { staticClass: "address-uploaded" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-error viewClose y-c-p",
                                    on: {
                                      click: function ($event) {
                                        _vm.sendUploadedImage = ""
                                      },
                                    },
                                  }),
                                  _c("img", {
                                    attrs: { src: _vm.sendUploadedImage },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "reutrn-box" }, [
            _c("div", { staticClass: "trangle" }),
            _c("div", { staticClass: "y-f y-f-a" }, [
              _c(
                "div",
                { staticClass: "y-f y-f-a y-f-fc icon-box" },
                [
                  _c("svg-icon", {
                    staticClass: "icon-send-style",
                    attrs: { "icon-class": "icon_Receive" },
                  }),
                  _c("span", { staticClass: "y-fc-systemcolor" }, [
                    _vm._v("收件地址"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "y-mt-10" }, [
                _c(
                  "div",
                  { staticClass: "y-f y-f-jb" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "receiveName" } },
                      [
                        _c("el-autocomplete", {
                          staticClass: "y-w-180",
                          attrs: {
                            "popper-class": "print-list_w500",
                            debounce: 0,
                            "fetch-suggestions": _vm.querySearchAsyncRecive,
                            placeholder: "请输入收件人姓名",
                            disabled: _vm.sourceOperation == 2,
                          },
                          on: { select: _vm.handleSelectRevice },
                          model: {
                            value: _vm.data.receiveName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.data,
                                "receiveName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "data.receiveName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "receiveMobile",
                        attrs: {
                          label: "",
                          prop: "receiveMobile",
                          "label-width": "0",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "y-w-180",
                          attrs: {
                            maxlength: 11,
                            placeholder: "请输入手机号码",
                            disabled: _vm.sourceOperation == 2,
                          },
                          model: {
                            value: _vm.data.receiveMobile,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "receiveMobile", $$v)
                            },
                            expression: "data.receiveMobile",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "receivePhone",
                        attrs: {
                          label: "",
                          prop: "receivePhone",
                          "label-width": "0",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "y-w-180",
                          attrs: {
                            maxlength: 20,
                            placeholder: "请输入电话号码",
                            disabled: _vm.sourceOperation == 2,
                          },
                          model: {
                            value: _vm.data.receivePhone,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "receivePhone", $$v)
                            },
                            expression: "data.receivePhone",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "district" } },
                      [
                        _c("regionSelector", {
                          ref: "areaList",
                          attrs: {
                            id: "Area",
                            isDisable: _vm.isReciveHy,
                            areaList: _vm.areaList,
                            sourceOperation: _vm.sourceOperation + "",
                            fromPage: "printList",
                          },
                          on: { changeRegion: _vm.changeRegion },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "y-f y-f-a y-f-jb big-screen" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "y-mb-0",
                        attrs: { label: "", prop: "receiveAddress" },
                      },
                      [
                        _c("el-input", {
                          staticClass: "y-w-400",
                          attrs: {
                            maxlength: 255,
                            placeholder: "请输入详细地址(街道、社区、门牌号等)",
                            disabled: _vm.sourceOperation == 2,
                          },
                          model: {
                            value: _vm.data.receiveAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "receiveAddress", $$v)
                            },
                            expression: "data.receiveAddress",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.sourceOperation != 2
                      ? _c(
                          "span",
                          {
                            staticClass: "clear-text systemColor",
                            on: { click: _vm.clearReciverInfo },
                          },
                          [_vm._v("清空内容")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "y-b-s y-h-120" }, [
                _c(
                  "div",
                  { staticClass: "anlysize-style y-b-s" },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        resize: "none",
                        rows: 4,
                        maxlength: 200,
                        placeholder:
                          "觉得填写麻烦？粘贴收件人信息到此处，点击一键解析，系统将自动填写。如 张三 18223459856 陕西省西安市雁塔区锦业路中心大厦",
                        disabled: _vm.sourceOperation == 2,
                      },
                      on: {
                        blur: function ($event) {
                          $event.stopPropagation()
                          return _vm.blurAddr("receive")
                        },
                      },
                      model: {
                        value: _vm.totalInfo,
                        callback: function ($$v) {
                          _vm.totalInfo = $$v
                        },
                        expression: "totalInfo",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "y-f y-f-je y-f-a" },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "identify-avatar-uploader",
                            attrs: {
                              action: "",
                              accept: ".jpg,.jpeg,.png",
                              disabled: _vm.sourceOperation == 2,
                              "show-file-list": false,
                              "before-upload": _vm.beforeAvatarUploadRecive,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "y-fc-999 align-right systemSize",
                                class: {
                                  systemColor: _vm.sourceOperation != 2,
                                },
                              },
                              [_vm._v("图片识别")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "systemColor align-right systemSize",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.smartResolve("receive")
                              },
                            },
                          },
                          [_vm._v("一键解析")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.reciveUploadedImage
                ? _c("div", { staticClass: "address-uploaded" }, [
                    _c("i", {
                      staticClass: "el-icon-error viewClose y-c-p",
                      on: {
                        click: function ($event) {
                          _vm.reciveUploadedImage = ""
                        },
                      },
                    }),
                    _c("img", { attrs: { src: _vm.reciveUploadedImage } }),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "reutrn-box" }, [
            _c("div", { staticClass: "trangle" }),
            _c("div", { staticClass: "y-f y-f-a y-mt-10" }, [
              _c(
                "div",
                { staticClass: "y-f y-f-a icon-box-small" },
                [
                  _c("svg-icon", {
                    staticClass: "icon-style",
                    attrs: { "icon-class": "icon_Time" },
                  }),
                  _c("span", { staticClass: "y-fc-systemcolor" }, [
                    _vm._v("取件时间"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "y-f y-f-a" }, [
                _c("span", { staticClass: "recive-select-btn y-mr-16" }, [
                  _c(
                    "span",
                    {
                      staticClass: "radio-btn y-mr-4",
                      class: { "active-radio-btn": _vm.data.timedPickup == 1 },
                      on: {
                        click: function ($event) {
                          return _vm.chageTimedPickupFn("1")
                        },
                      },
                    },
                    [_vm._v("当日取")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "radio-btn",
                      class: { "active-radio-btn": _vm.data.timedPickup == 2 },
                      on: {
                        click: function ($event) {
                          return _vm.chageTimedPickupFn("2")
                        },
                      },
                    },
                    [_vm._v("定时取")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "y-f y-f-a" },
                  [
                    _vm.data.timedPickup == 1
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "y-mb-0",
                            attrs: {
                              label: "",
                              "label-width": "0",
                              prop: "reciveTime",
                            },
                          },
                          [
                            _vm.isRefreshTime
                              ? _c("selectTime", {
                                  ref: "reciveTimeComponent",
                                  attrs: {
                                    receiveAddressInfo: _vm.receiveAddressInfo,
                                    typeFlag: "1",
                                    fromPage: "createOrder",
                                  },
                                  on: {
                                    selectedTime: _vm.selectedReciveTimeFn,
                                    setTimeType: _vm.chageTimedPickupFn,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.data.timedPickup == 2
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "y-mb-0",
                            attrs: {
                              label: "",
                              "label-width": "0",
                              prop: "selectedTime",
                            },
                          },
                          [
                            _vm.isRefreshTime
                              ? _c("selectTime", {
                                  ref: "selectedTimeComponent",
                                  attrs: {
                                    receiveAddressInfo: _vm.receiveAddressInfo,
                                    typeFlag: "2",
                                    fromPage: "createOrder",
                                  },
                                  on: {
                                    selectedTime: _vm.selectedTimeFn,
                                    setTimeType: _vm.chageTimedPickupFn,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "reutrn-box" }, [
            _c("div", { staticClass: "trangle" }),
            _c("div", { staticClass: "y-f y-f-a y-mt-10" }, [
              _c(
                "div",
                { staticClass: "y-f y-f-a icon-box-small" },
                [
                  _c("svg-icon", {
                    staticClass: "icon-style",
                    attrs: { "icon-class": "icon_File" },
                  }),
                  _c("span", { staticClass: "y-fc-systemcolor" }, [
                    _vm._v("商品信息"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {},
                _vm._l(_vm.data.orderProducts, function (good, gidx) {
                  return _c(
                    "div",
                    { key: "good_" + gidx, staticClass: "y-f y-f-js" },
                    [
                      _c("div", { staticClass: "y-f" }, [
                        _c(
                          "div",
                          [
                            _c("div", { staticClass: "y-mb-6" }, [
                              _c("span", [_vm._v("商品名称")]),
                              _c(
                                "span",
                                {
                                  staticClass: "y-fc-4C84FF y-c-p y-ml-8",
                                  on: { click: _vm.selectedGoodsOptions },
                                },
                                [_vm._v("设置")]
                              ),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "form-item-wrap-f",
                                attrs: {
                                  label: "",
                                  "label-width": "0",
                                  prop: "orderProducts." + gidx + ".goodName",
                                  rules: {
                                    required: true,
                                    message: "商品名称不能为空",
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  ref: `el_auto_${gidx}`,
                                  refInFor: true,
                                  staticClass: "y-f-l y-f-1 y-w-500",
                                  attrs: {
                                    clearable: "",
                                    "popper-class": "print-list_w500",
                                    "fetch-suggestions":
                                      _vm.querySearchAsyncProduct,
                                    debounce: 0,
                                    maxlength: 100,
                                    placeholder: "请输入商品名称",
                                  },
                                  on: {
                                    clear: function ($event) {
                                      return _vm.clearSelect(gidx)
                                    },
                                    change: (val, gidx) =>
                                      _vm.validName(val, gidx),
                                  },
                                  model: {
                                    value: good.goodName,
                                    callback: function ($$v) {
                                      _vm.$set(good, "goodName", $$v)
                                    },
                                    expression: "good.goodName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "y-ml-28" },
                          [
                            _c("div", { staticClass: "y-mb-6" }, [
                              _c("span", [_vm._v("商品数量")]),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "form-item-wrap-f",
                                attrs: { label: "", "label-width": "" },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "y-w-180",
                                  attrs: {
                                    disabled: _vm.sourceOperation == 2,
                                    min: 1,
                                    max: 99999,
                                    precision: 0,
                                    step: 1,
                                  },
                                  model: {
                                    value: good.goodNum,
                                    callback: function ($$v) {
                                      _vm.$set(good, "goodNum", $$v)
                                    },
                                    expression: "good.goodNum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            good.goodUrl
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass:
                                      "form-item-wrap-f imgUrl y-mt-10",
                                    attrs: { label: "", "label-width": "" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-error close-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImgUrl(gidx)
                                        },
                                      },
                                    }),
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "48px",
                                        height: "48px",
                                      },
                                      attrs: {
                                        src: good.goodUrl,
                                        "preview-src-list": [good.goodUrl],
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("div", { staticClass: "y-mb-6" }, [
                              _c("span", [_vm._v(" ")]),
                            ]),
                            gidx == 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "y-ml-25 addBtn",
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-plus",
                                    },
                                    on: { click: _vm.addProdcutInfoFn },
                                  },
                                  [_vm._v("添 加")]
                                )
                              : _vm._e(),
                            gidx > 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "normal-btn addBtn y-ml-25",
                                    attrs: {
                                      type: "buttom",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delProdcutInfoFn(gidx)
                                      },
                                    },
                                  },
                                  [_vm._v("删 除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "reutrn-box" }, [
            _c("div", { staticClass: "trangle" }),
            _c("div", { staticClass: "y-f y-f-a y-mt-10" }, [
              _c(
                "div",
                { staticClass: "y-f y-f-a icon-box-small" },
                [
                  _c("svg-icon", {
                    staticClass: "icon-style",
                    attrs: { "icon-class": "icon_Other" },
                  }),
                  _c("span", { staticClass: "y-fc-systemcolor" }, [
                    _vm._v("其他信息"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {},
                [
                  _c("div", { staticClass: "y-mb-6" }, [
                    _vm._v("预计包裹重量(kg)"),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "y-mb-0",
                      attrs: {
                        label: "",
                        "label-width": "0",
                        prop: "goodsWeight",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "y-w-180",
                        attrs: {
                          disabled: _vm.sourceOperation == 2,
                          min: 0.01,
                          max: 50,
                          precision: 2,
                          step: 1,
                        },
                        model: {
                          value: _vm.data.goodsWeight,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "goodsWeight", $$v)
                          },
                          expression: "data.goodsWeight",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "y-mb-6 y-mt-10" }, [
                    _vm._v("备注"),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "y-mb-0",
                      attrs: {
                        label: "",
                        "label-width": "0",
                        prop: "mallRemark",
                      },
                    },
                    [
                      _c("el-autocomplete", {
                        staticClass: "y-w-500",
                        attrs: {
                          clearable: "",
                          id: "remark-id",
                          "popper-class": "print-list_w500",
                          debounce: 0,
                          "fetch-suggestions": _vm.querySearchAsyncRemark,
                          maxlength: 200,
                          placeholder: "请输入备注",
                        },
                        on: { select: _vm.handleSelectRemark },
                        model: {
                          value: _vm.data.mallRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "mallRemark", $$v)
                          },
                          expression: "data.mallRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "fixed-box p40",
              class: {
                "bottom--m-m":
                  _vm.data.isCheckedBrokerage || _vm.data.isCheckedPayType,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "y-f y-f-a y-f-jc",
                  class: { "mt-34": !_vm.rewardCardBanlance },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "y-f y-f-fc",
                      class: {
                        "y-pb-20":
                          _vm.rewardCardBanlance &&
                          !_vm.data.isCheckedBrokerage &&
                          !_vm.data.isCheckedPayType,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "y-f y-f-ab y-fs-14",
                          class: { pl44: _vm.rewardCardBanlance },
                        },
                        [
                          _c("span", [_vm._v("本单预计运费：")]),
                          [
                            _c(
                              "span",
                              {
                                staticClass: "systemColor y-fs-22 y-mr-5 y-f-b",
                              },
                              [_vm._v(_vm._s(_vm.estimatedFreight))]
                            ),
                            _vm._v("元 "),
                          ],
                          _c("span", { staticClass: "y-ml-10" }, [
                            _vm._v("当前运费余额："),
                          ]),
                          _c("span", { staticClass: "y-fs-24 y-mr-5 y-f-b" }, [
                            _vm._v(_vm._s(_vm.balance)),
                          ]),
                          _vm._v("元 "),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "y-f y-f-a y-f-je y-ml-80" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "bottom--m-m",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.finishGoOn()
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "order-icon",
                            attrs: {
                              src: require("@/assets/images/icon/icon_Click@2x.png"),
                            },
                          }),
                          _vm._v("确认下单"),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "bottom--m-m",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.finishGoOn("print")
                            },
                          },
                        },
                        [_vm._v("下单并打印")]
                      ),
                      !_vm.isCheckedPrivacy
                        ? _c(
                            "el-checkbox",
                            {
                              staticClass: "y-ml-16",
                              model: {
                                value: _vm.isShowPrivacy,
                                callback: function ($$v) {
                                  _vm.isShowPrivacy = $$v
                                },
                                expression: "isShowPrivacy",
                              },
                            },
                            [_vm._v("我已阅读并同意")]
                          )
                        : _vm._e(),
                      !_vm.isCheckedPrivacy
                        ? _c(
                            "span",
                            {
                              staticClass: "systemColor y-c-p",
                              on: {
                                click: function ($event) {
                                  _vm.showPrivacyDialog = true
                                },
                              },
                            },
                            [_vm._v("《功能使用协议》")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm.addOptionsDialogVisble
        ? _c("addGoodsOptions", {
            attrs: { isShow: _vm.addOptionsDialogVisble },
            on: { closeGoodsOptions: _vm.closeGoodsOptions },
          })
        : _vm._e(),
      _vm.isShowIndentifyPicDialog
        ? _c("indentityPic", {
            attrs: {
              value: _vm.isShowIndentifyPicDialog,
              identifyType: _vm.identifyInfoType,
              imgUrl: _vm.imgUrl,
            },
            on: { close: _vm.closeIdentifyInfo, analysisPic: _vm.analysisPic },
          })
        : _vm._e(),
      _vm.showPrivacyDialog
        ? _c("privacy", {
            attrs: {
              isShow: _vm.showPrivacyDialog,
              isCheckedPrivacy: _vm.isShowPrivacy,
            },
            on: { close: _vm.closePrivacyDialog },
          })
        : _vm._e(),
      _vm.buyerPaysShippingDialogFlag
        ? _c("buyerPaysShippingDialog", {
            ref: "buyerPaysShippingDialog",
            attrs: {
              isShow: _vm.buyerPaysShippingDialogFlag,
              alipayName: _vm.alipayName,
            },
            on: {
              closeDialog: _vm.closeBuyerPaysShipping,
              changeBrokerage: _vm.changeBrokerage,
              openSaveAccount: _vm.openSaveAccount,
              goToRealName: _vm.goToRealName,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }